export interface WorkOrderPlanImpact {
  requires_confirmation?: boolean;
  preserved_plan_count?: number;
  preserved_steps?: any[];
  removed_plan_count?: number;
  removed_steps?: any[];
  new_plan_count?: number;
  new_steps?: any[];
  final_plan_count?: number;
  final_steps?: any[];
  confirmation_message?: string;
  [key: string]: any;
}

const stepsFromApi = (steps?: any[]) => Array.isArray(steps) ? steps : [];

export const readPlanImpact = (impact?: WorkOrderPlanImpact | null) => ({
  preservedSteps: stepsFromApi(impact?.preserved_steps),
  removedSteps: stepsFromApi(impact?.removed_steps),
  newSteps: stepsFromApi(impact?.new_steps),
  // finalSteps sengaja dikembalikan langsung dari response backend.
  // Jangan merge, sort, atau deduplicate di frontend.
  finalSteps: stepsFromApi(impact?.final_steps),
});

export const requiresPlanConfirmation = (impact?: WorkOrderPlanImpact | null) => impact?.requires_confirmation === true;

export const isApplyActionDisabled = (isStale: boolean, actionLoading: string) => Boolean(isStale || actionLoading);

export const isConfirmationApplyDisabled = (confirmed: boolean, actionLoading: string) => Boolean(!confirmed || actionLoading);

export const buildApplyPayload = (confirmRegeneratePlan: boolean) => ({
  confirm_regenerate_plan: confirmRegeneratePlan,
});

